import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IEstimateLineItemOptionData } from "common/records/EstimateLineItemOption";

export const RECEIVE_ESTIMATE_LINE_ITEM_OPTION = "@estimateLineItemOptions/RECEIVE_ESTIMATE_LINE_ITEM_OPTION";
export const DUPLICATE_ESTIMATE_LINE_ITEM_OPTION = "@estimateLineItemOptions/DUPLICATE_ESTIMATE_LINE_ITEM_OPTION";
export const UPDATE_ESTIMATE_LINE_ITEM_OPTION_TOTALS =
  "@estimateLineItemOptions/UPDATE_ESTIMATE_LINE_ITEM_OPTION_TOTALS";
export const DECREMENT_ESTIMATE_LINE_ITEM_OPTION_UNSAVED_ID =
  "@estimateLineItemOptions/DECREMENT_ESTIMATE_LINE_ITEM_OPTION_UNSAVED_ID";
export const SET_ESTIMATE_LINE_ITEM_OPTION_BY_ID = "@estimateLineItemOptions/SET_ESTIMATE_LINE_ITEM_OPTION_BY_ID";
export const COPY_ESTIMATE_LINE_ITEM_OPTION_TO_LAST_SAVED =
  "@estimateLineItemOptions/COPY_ESTIMATE_LINE_ITEM_OPTION_TO_LAST_SAVED";

export const EstimateLineItemOptionActions = {
  receiveEstimateLineItemOption: (estimateLineItemOption: Partial<IEstimateLineItemOptionData>) =>
    createAction(RECEIVE_ESTIMATE_LINE_ITEM_OPTION, { estimateLineItemOption }),
  /**
   * Duplicates an estimate line item option to a new line item
   *
   * @param sourceOptionId The id of the option to duplicate
   * @param targetLineItemId The id of the line item to add the duplicated option to
   */
  duplicateEstimateLineItemOption: (sourceOptionId: number, targetLineItemId: number) =>
    createAction(DUPLICATE_ESTIMATE_LINE_ITEM_OPTION, { sourceOptionId, targetLineItemId }),
  updateTotals: (estimateLineItemOptionId: number) =>
    createAction(UPDATE_ESTIMATE_LINE_ITEM_OPTION_TOTALS, { estimateLineItemOptionId }),
  decrementUnsavedId: () => createAction(DECREMENT_ESTIMATE_LINE_ITEM_OPTION_UNSAVED_ID),
  setEstimateLineItemOptionById: (
    estimateLineItemOptionId: number,
    estimateLineItemOption: Partial<IEstimateLineItemOptionData>,
  ) => createAction(SET_ESTIMATE_LINE_ITEM_OPTION_BY_ID, { estimateLineItemOptionId, estimateLineItemOption }),
  copyEstimateLineItemOptionToLastSaved: (estimateLineItemOptionId: number) =>
    createAction(COPY_ESTIMATE_LINE_ITEM_OPTION_TO_LAST_SAVED, { estimateLineItemOptionId }),
};

export type EstimateLineItemOptionActions = ActionsUnion<typeof EstimateLineItemOptionActions>;
